/**************************************************
 * Nombre:       Tarjeta_Ultima_Lista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import dayjs from 'dayjs'
import 'dayjs/locale/es'

const Tarjeta_Ultima_Lista = ({item = {}}) => {
    dayjs.locale('es')


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{border: 1, borderColor: '#00000050', p: 2, borderRadius: 2}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: 14, color: '#00000080'}}>Ultima lista enviada</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{fontWeight: 600}}>{dayjs(item.fecha).format('dddd - DD MMM YY - hh:mm a').toUpperCase()}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Ultima_Lista